import React from 'react';
import './../../assets/css/loading.scss';

const Loading = () => {
  return (
    <div className='loading-battery-container'>
      <div className="loading-battery grid gap-0 row-gap-3">
        <div className="liquid g-col"></div>
        <div  className='loading-text p-4 g-col'>
          <h6>Loading...</h6>
        </div>
      </div>
    </div>
  )
};

export default Loading;
